import { Colors } from 'msteams-ui-styles-core/lib/colors';
import { CSSProperties } from 'react';
import { ThemeString } from '../components/../context';

export const pageFontSize: () => number = () => {
  let sizeStr = window
    .getComputedStyle(document.getElementsByTagName('html')[0])
    .getPropertyValue('font-size');
  sizeStr = sizeStr.replace('px', '');
  let fontSize = parseInt(sizeStr, 10);
  if (!fontSize) {
    fontSize = 12;
  }
  return fontSize;
};

export const defaultFont = {
  fontFamily: 'Segoe UI, Open Sans',
  fontSize: '14px',
  fontWeight: 400,
} as CSSProperties;

export const centeredFull = {
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
} as CSSProperties;

export function themedText(theme: ThemeString): CSSProperties {
  return {
    color: primaryTextColor(theme),
    backgroundColor: canvasBackgroundColor(theme),
  };
}

export function themedButtonText(theme: ThemeString): CSSProperties {
  return {
    color: canvasBackgroundColor(theme),
    backgroundColor: primaryButtonColor(theme),
  };
}

/**
 * Used for headers and base text
 */
export function primaryTextColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.white;
    case 'contrast':
      return Colors.highContrast.white;
    default:
      return Colors.light.black;
  }
}

/**
 * Used for labels, subheads, attributions, and icon buttons
 */
export function secondaryTextColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.gray02;
    case 'contrast':
      return Colors.highContrast.green;
    default:
      return Colors.light.gray02;
  }
}

/**
 * Used for message previews and help text
 */
export function tertiaryTextColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.gray03;
    case 'contrast':
      return Colors.highContrast.yellow;
    default:
      return Colors.light.gray03;
  }
}

/**
 * Used for timestamps
 */
export function timestampColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.gray04;
    case 'contrast':
      return Colors.highContrast.yellow;
    default:
      return Colors.light.gray04;
  }
}

/**
 * Used for disabled text
 */
export function disabledTextColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.gray06;
    case 'contrast':
      return Colors.highContrast.blue;
    default:
      return Colors.light.gray06;
  }
}

/**
 * Used for separators, borders, channel dividers, and banner backgrounds
 */
export function separatorColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.gray08;
    case 'contrast':
      return Colors.highContrast.black;
    default:
      return Colors.light.gray08;
  }
}

/**
 * Used for main canvas color (light), channel replies, and message bubbles
 */
export function messageBubbleColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.gray10;
    case 'contrast':
      return Colors.highContrast.black;
    default:
      return Colors.light.gray10;
  }
}

/**
 * Used for disabled buttons, card borders, header, nav bar, chat bubbles, initial thread, and popups
 */
export function disabledButtonColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.brand00SemiTransparent;
    case 'contrast':
      return Colors.highContrast.blue;
    default:
      return Colors.light.brand00SemiTransparent;
  }
}

/**
 * Used for canvas background
 */
export function canvasBackgroundColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      // TODO: Migrate to a newer Teams component library.
      return '#292929';
    case 'contrast':
      return Colors.highContrast.black;
    default:
      return Colors.light.white;
  }
}

export function headerBarColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.gray14;
    case 'contrast':
      return Colors.highContrast.black;
    default:
      return Colors.light.gray14;
  }
}

/**
 * Used for primary buttons, icon button hover states, and navigation indicators
 */
export function primaryButtonColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.brand00;
    case 'contrast':
      return Colors.highContrast.green;
    default:
      return Colors.light.brand00;
  }
}

/**
 * Used for primary buttons, icon button hover states, and navigation indicators
 */
export function notificationColor(theme: ThemeString): string {
  switch (theme) {
    case 'dark':
      return Colors.dark.red;
    case 'contrast':
      return Colors.highContrast.yellow;
    default:
      return Colors.light.red;
  }
}
